module.exports = __webpack_public_path__ + "media/images/countryrect/cr-9f4f801817c177593e6c659a983d73d7.svg";